import classNames from 'classnames';
import { useState } from 'react';
import styles from './index.module.scss';
import EFArrowDown from '@/efelement/EFIcon/EFArrowDown';

interface EFCollapseParams {
    data: any;
    children?: React.ReactNode;
    theme?: string;
    className?: string;
    type?: string;
    onClick?: any;
}

const EFCollapse = ({ data, className = '', theme = 'light', ...rest }: EFCollapseParams) => {
    const prefixCls = 'ef-collapse';
    const [selList, setSelList] = useState<number[]>([]);
    const classString = classNames(prefixCls, styles.efcollapse, className, {
        [`${prefixCls}-dark`]: theme === 'dark',
    });
    const toggleHandel = (index: any) => {
        const listA = JSON.parse(JSON.stringify(selList));
        const pos = listA.indexOf(index);
        if (pos > -1) {
            //有
            listA.splice(pos, 1);
        } else {
            //无
            listA.push(index);
        }

        setSelList(listA);
    };
    // console.log('data', data);
    return (
        <ul className={classString} {...rest}>
            {data.map((item: any, index: number) => {
                return (
                    <li
                        key={index}
                        className={`${prefixCls}-item${selList.includes(index) ? ` ${prefixCls}-item-active` : ''}`}
                        onClick={() => {
                            toggleHandel(index);
                        }}
                    >
                        <div className={`${prefixCls}-title`}>
                            {item.title}
                            <EFArrowDown />
                        </div>
                        <div className={`${prefixCls}-content`}>{item.description || item.desc}</div>
                    </li>
                );
            })}
        </ul>
    );
};

export default EFCollapse;
